import _ from 'lodash';
import React from 'react';
import { navigation } from '../../../utils';

import styles from './breadcrumbs.scss';

import {
  BreadcrumbsOption,
  BreadcrumbsOptionWithId,
} from './breadcrumbs.types';
import {
  Breadcrumbs as WixBreadcrumbs,
  BreadcrumbsTheme,
  Text,
} from '@wix/design-system';

interface Props {
  dataHook?: string;
  items: BreadcrumbsOption[];
  organizationId?: string;
  projectId?: string;
  theme?: BreadcrumbsTheme;

  onClick?(BreadcrumbsOptionWithId): any;
}

class Breadcrumbs extends React.Component<Props> {
  public static defaultProps = {
    items: [],
  };

  public itemsToBreadcrumbsItems(
    items: BreadcrumbsOption[],
  ): BreadcrumbsOptionWithId[] {
    const { dataHook } = this.props;

    return _.map(
      items,
      (item: BreadcrumbsOption, index: number): BreadcrumbsOptionWithId => ({
        ...item,
        id: `${dataHook}-breadcrumb-${index}`,
      }),
    );
  }

  public getActiveId(): string | undefined {
    const breadcrumbs = this.getBreadcrumbs();
    const lastBreadcrumb = _.last<BreadcrumbsOptionWithId>(breadcrumbs);

    if (_.size(breadcrumbs) > 1) {
      return lastBreadcrumb && lastBreadcrumb.id;
    }

    return;
  }

  public getBreadcrumbs(): BreadcrumbsOptionWithId[] {
    const { items } = this.props;

    return this.itemsToBreadcrumbsItems(items);
  }

  public onClick(breadcrumb: BreadcrumbsOptionWithId): void {
    const { onClick, organizationId, projectId } = this.props;

    if (onClick) {
      return onClick(breadcrumb);
    }

    if (!breadcrumb.path || breadcrumb.id === this.getActiveId()) {
      return;
    }

    navigation.goToPath(breadcrumb.path, { organizationId, projectId });
  }

  public render() {
    const { dataHook, theme } = this.props;

    const breadcrumbs = this.getBreadcrumbs();
    const activeId = this.getActiveId();

    return (
      <div className={styles.breadcrumbs}>
        <Text size="small" weight="normal" secondary>
          <WixBreadcrumbs
            items={breadcrumbs}
            onClick={this.onClick.bind(this)}
            activeId={activeId}
            dataHook={dataHook}
            theme={theme}
          />
        </Text>
      </div>
    );
  }
}

export default Breadcrumbs;
